// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Navbar from "./Home/Navbar";
// import ParentComponent from "./Home/Parent";
// import Adv from "./Home/Adv";
// import Footer from "./Home/Footer";
// import Special from "./Home/Special";
// import SignupModal from "./Auth/Overlay.jsx";
// import Carousel from "react-bootstrap/Carousel";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import axios from "axios";

// function Home() {
//   const navigate = useNavigate();
//   const [refresh, setRefresh] = useState(true);
//   const [uid, setUid] = useState(null);
//   const [access, setAccess] = useState(null);
//   const [index, setIndex] = useState(0);
//   const [banners, setBanners] = useState([]);
//   const [loadingBanners, setLoadingBanners] = useState(true);
//   const [bannerError, setBannerError] = useState(null);
//   const [advertisements, setAdvertisements] = useState([]);
//   const [loadingAds, setLoadingAds] = useState(true);
//   const [adError, setAdError] = useState(null);

//   const handleSelect = (selectedIndex) => {
//     setIndex(selectedIndex);
//   };

//   const refRestCart = () => setRefresh(!refresh);

//   const [showSignup, setShowSignup] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowSignup(true);
//     }, 3000);

//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     const storedUid = localStorage.getItem("user_id");
//     const storedAccess = localStorage.getItem("access_token");

//     if (!storedUid || !storedAccess) {
//       // navigate("/login");
//     } else {
//       setUid(storedUid);
//       setAccess(storedAccess);
//     }
//   }, [navigate]);

//   // Fetch banners
//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         setLoadingBanners(true);
//         const response = await axios.get("https://backend.frozenwala.com/api/banners/");

//         const activeBanners = response.data.filter(
//           (banner) => banner.status === true
//         );

//         const formattedBanners = activeBanners.map((banner) => ({
//           id: banner.id,
//           image: banner.add_photo,
//           title: banner.title,
//           description: banner.description,
//           originalData: banner,
//         }));

//         setBanners(formattedBanners);
//         setBannerError(null);
//       } catch (err) {
//         console.error("Failed to fetch banners:", err);
//         setBannerError("Failed to load banners. Please try again later.");
//       } finally {
//         setLoadingBanners(false);
//       }
//     };

//     fetchBanners();
//   }, []);

//   // Fetch advertisements
//   useEffect(() => {
//     const fetchAdvertisements = async () => {
//       try {
//         setLoadingAds(true);
//         const response = await axios.get(`https://backend.frozenwala.com/api/adds/`);

//         // Filter only active advertisements with status: true
//         const activeAds = response.data.filter((ad) => ad.status === true);

//         const formattedAds = activeAds.map((ad) => ({
//           id: ad.id,
//           image: ad.add_photo,
//           title: ad.title,
//           description: ad.description,
//           created_at: ad.created_at,
//           category: ad.category,
//           originalData: ad,
//         }));

//         setAdvertisements(formattedAds);
//         setAdError(null);
//       } catch (err) {
//         console.error("Failed to fetch advertisements:", err);
//         setAdError("Failed to load advertisements.");
//       } finally {
//         setLoadingAds(false);
//       }
//     };

//     fetchAdvertisements();
//   }, []);

//   // Slider settings for advertisement carousel
//   const adSettings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     arrows: true,
//     pauseOnHover: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: false,
//         }
//       }
//     ]
//   };

//   return (
//     <div>
//       <main className="main" id="top">
//         {!access && (
//           <SignupModal show={showSignup} onClose={() => setShowSignup(false)} />
//         )}
//         <Navbar refreshCart={refresh} />

//         {/* Banner Carousel */}
//         <div style={{background: "#fff"}}>
//           <div className="container banner-carousel-container">
//             {loadingBanners ? (
//               <div className="text-center py-5">
//                 <div className="spinner-border text-primary" role="status">
//                   <span className="visually-hidden">Loading banners...</span>
//                 </div>
//                 <p className="mt-2">Loading banners...</p>
//               </div>
//             ) : bannerError ? (
//               <div className="alert alert-warning text-center" role="alert">
//                 {bannerError}
//               </div>
//             ) : (
//               <Carousel
//                 activeIndex={index}
//                 onSelect={handleSelect}
//                 interval={3000}
//                 fade
//                 indicators={banners.length > 1}
//                 controls={false}
//               >
//                 {banners.map((slide, idx) => (
//                   <Carousel.Item key={slide.id || idx}>
//                     <img
//                       className="d-block w-100 banner-image"
//                       src={slide.image}
//                       alt={`Banner ${idx + 1}`}
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src = "/img/gallery/banner1.jpg"; // Fallback image
//                       }}
//                       style={{
//                         height: "500px",
//                         objectFit: "cover",
//                         width: "100%",
//                       }}
//                     />

//                     <Carousel.Caption className="banner-caption text-center">
//                       <h2 className="banner-text">{slide.description}</h2>
//                     </Carousel.Caption>
//                   </Carousel.Item>
//                 ))}
//               </Carousel>
//             )}
//           </div>
//         </div>

//         <ParentComponent refRestCart={refRestCart} uid={uid} advertisements={advertisements} loadingAds={loadingAds} adError={adError} adSettings={adSettings} />

//         <Adv />

//         <Special access={access} uid={uid} />

//         <section className="py-0 container">
//           <div
//             className="bg-holder"
//             style={{
//               backgroundImage: "url(/img/gallery/cta-two-bg.png)",
//               backgroundPosition: "center",
//               backgroundSize: "cover",
//             }}
//           ></div>

//           <div className="container">
//             <div className="row flex-center">
//               <div className="col-xxl-9 py-7 text-center">
//                 <h1 className="fw-bold mb-4 text-white fs-6">
//                   Are you ready to order <br />
//                   with the best deals?{" "}
//                 </h1>
//                 <a className="btn btn-danger" href="/menu">
//                   {" "}
//                   PROCEED TO ORDER<i className="fas fa-chevron-right ms-2"></i>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </section>

//         <Footer />
//       </main>
//     </div>
//   );
// }

// export default Home;


// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Navbar from "./Home/Navbar";
// import ParentComponent from "./Home/Parent";
// import Adv from "./Home/Adv";
// import Footer from "./Home/Footer";
// import Special from "./Home/Special";
// import SignupModal from "./Auth/Overlay.jsx";
// import Carousel from "react-bootstrap/Carousel";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { FaFilter, FaSearch, FaStore, FaUtensils, FaClock, FaHamburger, FaThLarge } from "react-icons/fa";

// function Home() {
//   const navigate = useNavigate();
//   const [refresh, setRefresh] = useState(true);
//   const [uid, setUid] = useState(null);
//   const [access, setAccess] = useState(null);
//   const [index, setIndex] = useState(0);
//   const [banners, setBanners] = useState([]);
//   const [loadingBanners, setLoadingBanners] = useState(true);
//   const [bannerError, setBannerError] = useState(null);
//   const [advertisements, setAdvertisements] = useState([]);
//   const [loadingAds, setLoadingAds] = useState(true);
//   const [adError, setAdError] = useState(null);

//   // Brand filter states
//   const [brands, setBrands] = useState([]);
//   const [loadingBrands, setLoadingBrands] = useState(true);
//   const [brandError, setBrandError] = useState(null);
//   const [selectedBrands, setSelectedBrands] = useState([]);

//   // Responsive Drawer State
//   const [showDrawer, setShowDrawer] = useState(false);

//   // Search queries
//   const [brandSearch, setBrandSearch] = useState("");
//   const [mainSearchQuery, setMainSearchQuery] = useState("");
//   const [isSearching, setIsSearching] = useState(false);

//   // Dynamic Scroll Position Tracker State
//   const [isScrolledPastHero, setIsScrolledPastHero] = useState(false);

//   const handleSelect = (selectedIndex) => {
//     setIndex(selectedIndex);
//   };

//   const refRestCart = () => setRefresh(!refresh);

//   const [showSignup, setShowSignup] = useState(false);

//   // Track scroll depth globally
//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 420) {
//         setIsScrolledPastHero(true);
//       } else {
//         setIsScrolledPastHero(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Handle brand checkbox/card change
//   const handleBrandChange = (brandName) => {
//     setSelectedBrands((prev) => {
//       if (prev.includes(brandName)) {
//         return prev.filter((b) => b !== brandName);
//       } else {
//         return [...prev, brandName];
//       }
//     });
//   };

//   // Main Banner Search Logic
//   const handleMainSearchSubmit = async (e) => {
//     e.preventDefault();
//     if (!mainSearchQuery.trim()) {
//       toast.warning("Please enter a search term!");
//       return;
//     }
//     setIsSearching(true);
//     try {
//       const response = await axios.get(
//         `https://backend.frozenwala.com/api/product/search/?q=${mainSearchQuery}&page=1&page_size=16`
//       );
//       navigate("/search", {
//         state: { results: response.data.results, query: mainSearchQuery },
//       });
//     } catch (error) {
//       console.error("Search error:", error);
//       toast.error("No Result Found!");
//     } finally {
//       setIsSearching(false);
//     }
//   };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowSignup(true);
//     }, 3000);

//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     const storedUid = localStorage.getItem("user_id");
//     const storedAccess = localStorage.getItem("access_token");

//     if (!storedUid || !storedAccess) {
//       // navigate("/login");
//     } else {
//       setUid(storedUid);
//       setAccess(storedAccess);
//     }
//   }, [navigate]);

//   // Fetch banners
//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         setLoadingBanners(true);
//         const response = await axios.get("https://backend.frozenwala.com/api/banners/");

//         const activeBanners = response.data.filter(
//           (banner) => banner.status === true
//         );

//         const formattedBanners = activeBanners.map((banner) => ({
//           id: banner.id,
//           image: banner.add_photo,
//           title: banner.title,
//           description: banner.description,
//           originalData: banner,
//         }));

//         setBanners(formattedBanners);
//         setBannerError(null);
//       } catch (err) {
//         console.error("Failed to fetch banners:", err);
//         setBannerError("Failed to load banners. Please try again later.");
//       } finally {
//         setLoadingBanners(false);
//       }
//     };

//     fetchBanners();
//   }, []);

//   // Fetch advertisements
//   useEffect(() => {
//     const fetchAdvertisements = async () => {
//       try {
//         setLoadingAds(true);
//         const response = await axios.get(`https://backend.frozenwala.com/api/adds/`);

//         const activeAds = response.data.filter((ad) => ad.status === true);

//         const formattedAds = activeAds.map((ad) => ({
//           id: ad.id,
//           image: ad.add_photo,
//           title: ad.title,
//           description: ad.description,
//           created_at: ad.created_at,
//           category: ad.category,
//           originalData: ad,
//         }));

//         setAdvertisements(formattedAds);
//         setAdError(null);
//       } catch (err) {
//         console.error("Failed to fetch advertisements:", err);
//         setAdError("Failed to load advertisements.");
//       } finally {
//         setLoadingAds(false);
//       }
//     };

//     fetchAdvertisements();
//   }, []);

//   useEffect(() => {
//     const fetchBrands = async () => {
//       try {
//         setLoadingBrands(true);
//         const response = await axios.get("https://backend.frozenwala.com/api/item-brands/");

//         let brandList = response.data;

//         if (brandList.length > 0 && typeof brandList[0] === "object") {
//           brandList = brandList.map((item) => item.name || item.brand_name || item.title);
//         }

//         // Sort alphabetically for grouping
//         brandList.sort((a, b) => a.localeCompare(b));
//         setBrands(brandList);
//         setBrandError(null);
//       } catch (err) {
//         console.error("Failed to fetch brands:", err);
//         setBrandError("Failed to load brands.");
//       } finally {
//         setLoadingBrands(false);
//       }
//     };

//     fetchBrands();
//   }, []);

//   // Filter brands based on search and group alphabetically
//   const filteredBrands = brands.filter((brand) =>
//     brand.toLowerCase().includes(brandSearch.toLowerCase())
//   );

//   // Group filtered brands by first letter
//   const groupedBrands = filteredBrands.reduce((groups, brand) => {
//     const firstLetter = brand.charAt(0).toUpperCase();
//     if (!groups[firstLetter]) {
//       groups[firstLetter] = [];
//     }
//     groups[firstLetter].push(brand);
//     return groups;
//   }, {});

//   const adSettings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     arrows: true,
//     pauseOnHover: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows: false,
//         },
//       },
//     ],
//   };

//   // Brand list component (reused in drawer)
//   const BrandList = () => (
//     <>
//       {loadingBrands ? (
//         <div className="text-center py-3">
//           <div className="spinner-border spinner-border-sm text-primary" role="status" />
//         </div>
//       ) : brandError ? (
//         <div className="alert alert-warning small py-1 px-2">{brandError}</div>
//       ) : Object.keys(groupedBrands).length === 0 ? (
//         <p className="text-muted small">No brands found</p>
//       ) : (
//         Object.keys(groupedBrands)
//           .sort()
//           .map((letter) => (
//             <div key={letter} className="mb-4">
//               <div
//                 style={{
//                   fontWeight: 700,
//                   fontSize: "13px",
//                   color: "#5dc5fa",
//                   borderBottom: "1px solid #eee",
//                   paddingBottom: "4px",
//                   marginBottom: "10px",
//                 }}
//               >
//                 {letter}
//               </div>
//               {groupedBrands[letter].map((brand, idx) => (
//                 <div
//                   key={`${letter}-${idx}`}
//                   className="mb-2 d-flex align-items-center gap-3 p-2 rounded"
//                   style={{ cursor: "pointer", transition: "0.2s" }}
//                   onMouseOver={(e) => (e.currentTarget.style.background = "#f8f9fa")}
//                   onMouseOut={(e) => (e.currentTarget.style.background = "transparent")}
//                   onClick={() => handleBrandChange(brand)}
//                 >
//                   <div
//                     style={{
//                       width: "35px",
//                       height: "35px",
//                       borderRadius: "50%",
//                       background: selectedBrands.includes(brand) ? "#5dc5fa" : "#eee",
//                       display: "flex",
//                       justifyContent: "center",
//                       alignItems: "center",
//                       overflow: "hidden",
//                       transition: "0.2s",
//                     }}
//                   >
//                     <FaHamburger size={14} color={selectedBrands.includes(brand) ? "#fff" : "#5dc5fa"} />
//                   </div>
//                   <span
//                     style={{
//                       fontSize: "14px",
//                       fontWeight: selectedBrands.includes(brand) ? "700" : "500",
//                       color: selectedBrands.includes(brand) ? "#5dc5fa" : "#333",
//                     }}
//                   >
//                     {brand}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           ))
//       )}
//     </>
//   );

//   return (
//     <div style={{ overflowX: "hidden" }}>
//       <main className="main" id="top">
//         {!access && (
//           <SignupModal show={showSignup} onClose={() => setShowSignup(false)} />
//         )}
//         <Navbar refreshCart={refresh} isCollapsedTop={isScrolledPastHero} />

//         {/* Dynamic Global Media Query Override Blocks */}
//         <style>{`
//           @media (max-width: 991.98px) {
//             .main-layout-container { margin-top: 15px !important; }
//           }

//           /* Web View Specific Overrides to Expand Banner and Clear Navbar */
//           @media (min-width: 992px) {
//             .desktop-hero-img {
//               height: clamp(460px, 66vh, 700px) !important;
//             }
//             .desktop-hero-content {
//               padding-top: max(130px, 16vh) !important;
//             }
//           }

//           /* Custom scrollbar for filter panel */
//           .filter-scroll::-webkit-scrollbar {
//             width: 6px;
//           }
//           .filter-scroll::-webkit-scrollbar-track {
//             background: #f1f1f1;
//             border-radius: 10px;
//           }
//           .filter-scroll::-webkit-scrollbar-thumb {
//             background: #bbb;
//             border-radius: 10px;
//           }
//           .filter-scroll::-webkit-scrollbar-thumb:hover {
//             background: #888;
//             border-radius: 10px;
//           }

//           /* Hide scrollbar for categories */
//           .category-container::-webkit-scrollbar { display: none; }
//           .category-container { -ms-overflow-style: none; scrollbar-width: none; }
//           .category-card { transition: 0.3s; }
//           .category-card:hover { transform: translateY(-5px); box-shadow: 0 4px 15px rgba(0,0,0,0.05); }
//         `}</style>

//         {/* Added top margin layout rules to physically detach the content layout away from the viewport ceiling */}
//         <div className="container-fluid main-layout-container" style={{ marginTop: "24px", paddingLeft: "24px", paddingRight: "24px" }}>
//           <div className="row">
//             {/* Slide Drawer Overlay for "View All" Brands */}
//             <Offcanvas show={showDrawer} onHide={() => setShowDrawer(false)} placement="start" style={{ width: "300px" }}>
//               <Offcanvas.Header closeButton className="border-b">
//                 <Offcanvas.Title className="fw-bold fs-5 d-flex align-items-center gap-2" style={{ color: "#5dc5fa" }}>
//                   <FaThLarge size={14} /> All Brands
//                 </Offcanvas.Title>
//               </Offcanvas.Header>
//               <Offcanvas.Body style={{ overflowY: "auto", display: "flex", flexDirection: "column" }}>
//                 <div className="input-group mb-3" style={{ borderRadius: "50px", overflow: "hidden" }}>
//                   <span className="input-group-text" style={{ background: "#fff", border: "1px solid #ddd", borderRight: "none", borderRadius: "50px 0 0 50px" }}>
//                     <FaSearch size={14} color="#aaa" />
//                   </span>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search brands..."
//                     value={brandSearch}
//                     onChange={(e) => setBrandSearch(e.target.value)}
//                     style={{
//                       border: "1px solid #ddd",
//                       borderLeft: "none",
//                       borderRadius: "0 50px 50px 0",
//                       fontSize: "14px",
//                       padding: "8px 12px",
//                     }}
//                   />
//                 </div>
//                 <div className="filter-scroll" style={{ flex: 1, overflowY: "auto" }}>
//                   <BrandList />
//                 </div>
//               </Offcanvas.Body>
//             </Offcanvas>

//             {/* Content Area */}
//             <div className="col-12 main-content-area" style={{ paddingLeft: "15px", paddingRight: "15px" }}>

//               {/* --- 1. HERO BANNER WITH PADDING TOP INJECTION TO CLEAR OVERLAID NAVBAR --- */}
//               <div 
//                 className="hero-section position-relative mb-4" 
//                 style={{ 
//                   borderRadius: "20px", 
//                   overflow: "hidden", 
//                   boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
//                   isolation: "isolate", // Locks rendering layout to parent boundary context
//                   transform: "translateZ(0)" // Forces modern rendering engines to strictly respect overflow radius tags
//                 }}
//               >
//                 {loadingBanners ? (
//                   <div className="text-center py-5 bg-white">
//                     <div className="spinner-border text-primary" role="status">
//                       <span className="visually-hidden">Loading banners...</span>
//                     </div>
//                     <p className="mt-2">Loading banners...</p>
//                   </div>
//                 ) : bannerError ? (
//                   <div className="alert alert-warning text-center" role="alert">{bannerError}</div>
//                 ) : (
//                   <Carousel activeIndex={index} onSelect={handleSelect} interval={3000} wrap={true} fade indicators={false} controls={false}>
//                     {banners.map((slide, idx) => (
//                       <Carousel.Item key={slide.id || idx} style={{ borderRadius: "20px", overflow: "hidden" }}>
//                         <img
//                           className="d-block w-100 desktop-hero-img"
//                           src={slide.image}
//                           alt={`Banner ${idx + 1}`}
//                           onError={(e) => {
//                             e.target.onerror = null;
//                             e.target.src = "/img/gallery/banner1.jpg";
//                           }}
//                           style={{
//                             height: "clamp(380px, 58vh, 600px)",
//                             objectFit: "cover",
//                             width: "100%",
//                             borderRadius: "20px"
//                           }}
//                         />
//                       </Carousel.Item>
//                     ))}
//                   </Carousel>
//                 )}

//                 {/* Dark Gradient Overlay for text readability */}
//                 <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: "linear-gradient(90deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 60%, transparent 100%)", zIndex: 2, borderRadius: "20px" }}></div>

//                 {/* Secure Flexbox Container Layout without static space leaks */}
//                 <div 
//                   className="position-absolute w-100 h-100 top-0 start-0 d-flex flex-column justify-content-center desktop-hero-content" 
//                   style={{ 
//                     zIndex: 3, 
//                     paddingLeft: "clamp(20px, 5vw, 70px)", 
//                     paddingRight: "20px",
//                     paddingTop: "max(90px, 12vh)",
//                     paddingBottom: "20px",
//                     overflow: "hidden"
//                   }}
//                 >
//                   {/* Content Container Area tailored to cleanly avoid clipping on mobile viewports */}
//                   <div className="d-flex flex-column justify-content-center w-100">
//                     <h1 className="fw-bold mb-2 text-white" style={{ fontSize: "clamp(1.5rem, 3.8vw, 3.2rem)", lineHeight: "1.2" }}>
//                       Delicious Food<br/> At Your <span style={{ color: "#5dc5fa" }}>Doorstep</span>
//                     </h1>
//                     <p className="mb-3 mb-md-4 text-light" style={{ fontSize: "clamp(13px, 1.5vw, 16px)", opacity: 0.95 }}>Order from your favourite restaurants and enjoy fast delivery.</p>

//                     {/* Search Bar Container */}
//                     <form onSubmit={handleMainSearchSubmit} className="d-flex align-items-center bg-white rounded-3 p-1 p-sm-2 shadow-lg" style={{ maxWidth: "520px", width: "100%" }}>
//                       <FaSearch className="ms-2 ms-sm-3 text-muted" size={17} style={{ minWidth: "17px" }} />
//                       <input 
//                         type="text" 
//                         className="form-control border-0 shadow-none px-2 px-sm-3" 
//                         style={{ fontSize: "clamp(13px, 1.4vw, 15px)", height: "clamp(36px, 5vh, 44px)" }} 
//                         placeholder="Search for item or poduct..." 
//                         value={mainSearchQuery} 
//                         onChange={(e) => setMainSearchQuery(e.target.value)} 
//                       />
//                       <button type="submit" disabled={isSearching} className="btn fw-bold px-3 px-sm-4 rounded-2" style={{ background: "#5dc5fa", color: "#fff", fontSize: "clamp(13px, 1.4vw, 15px)", height: "clamp(36px, 5vh, 44px)" }}>
//                         {isSearching ? "..." : "Search"}
//                       </button>
//                     </form>

//                     {/* Highlights layout configuration */}
//                     <div className="d-flex align-items-center mt-3 mt-md-4 gap-2 gap-sm-4 flex-wrap">
//                       <div className="d-flex align-items-center gap-2">
//                         <FaStore size={20} color="#5dc5fa" />
//                         <div><h6 className="mb-0 fw-bold text-white" style={{ fontSize: "clamp(0.95rem, 1.5vw, 1.15rem)" }}>200+</h6><small className="text-light" style={{ fontSize: "11px" }}>Products</small></div>
//                       </div>
//                       <div style={{ width: "1px", height: "28px", background: "rgba(255,255,255,0.3)" }}></div>
//                       <div className="d-flex align-items-center gap-2">
//                         <FaUtensils size={20} color="#5dc5fa" />
//                         <div><h6 className="mb-0 fw-bold text-white" style={{ fontSize: "clamp(0.95rem, 1.5vw, 1.15rem)" }}>1500+</h6><small className="text-light" style={{ fontSize: "11px" }}>Dishes</small></div>
//                       </div>
//                       <div style={{ width: "1px", height: "28px", background: "rgba(255,255,255,0.3)" }}></div>

//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* --- 2. FILTER BY BRANDS SECTION --- */}
//               <div className="mb-4 text-center">
//                 <h5 className="fw-bold mb-3 text-dark" style={{ fontSize: "18px" }}>
//                   Filter by Brands
//                 </h5>

//                 <div className="d-flex justify-content-center">
//                   <div
//                     className="d-flex gap-3 overflow-auto pb-3 pt-1 category-container"
//                     style={{
//                       scrollBehavior: "smooth",
//                       maxWidth: "100%",
//                       paddingLeft: "4px",
//                       paddingRight: "4px",
//                     }}
//                   >
//                     {brands.slice(0, 7).map((brand, idx) => {
//                       const isSelected = selectedBrands.includes(brand);
//                       return (
//                         <div
//                           key={idx}
//                           onClick={() => handleBrandChange(brand)}
//                           className="category-card text-center"
//                           style={{
//                             minWidth: "145px",
//                             border: isSelected
//                               ? "2px solid #5dc5fa"
//                               : "1px solid rgba(0,0,0,0.06)",
//                             borderRadius: "24px",
//                             padding: "20px 12px",
//                             cursor: "pointer",
//                             background: isSelected
//                               ? "linear-gradient(145deg, #FFF5F0 0%, #FFFFFF 100%)"
//                               : "#ffffff",
//                             transition: "all 0.25s ease",
//                             boxShadow: isSelected
//                               ? "0 10px 24px rgba(241, 114, 40, 0.25)"
//                               : "0 4px 16px rgba(0,0,0,0.06)",
//                           }}
//                           onMouseOver={(e) => {
//                             e.currentTarget.style.transform = "translateY(-6px)";
//                             e.currentTarget.style.boxShadow = isSelected
//                               ? "0 14px 28px rgba(241, 114, 40, 0.30)"
//                               : "0 8px 20px rgba(0,0,0,0.12)";
//                           }}
//                           onMouseOut={(e) => {
//                             e.currentTarget.style.transform = "translateY(0)";
//                             e.currentTarget.style.boxShadow = isSelected
//                               ? "0 10px 24px rgba(241, 114, 40, 0.25)"
//                               : "0 4px 16px rgba(0,0,0,0.06)";
//                           }}
//                         >
//                           <div
//                             className="mx-auto d-flex justify-content-center align-items-center"
//                             style={{
//                               width: "72px",
//                               height: "72px",
//                               borderRadius: "50%",
//                               background: isSelected
//                                 ? "linear-gradient(135deg, #5dc5fa, #5dc5fa)"
//                                 : "linear-gradient(135deg, #f8f9fa, #e9ecef)",
//                               overflow: "hidden",
//                               transition: "0.3s",
//                               boxShadow: isSelected
//                                 ? "0 6px 18px rgba(241, 114, 40, 0.45)"
//                                 : "0 2px 8px rgba(0,0,0,0.08)",
//                             }}
//                           >
//                             <FaHamburger size={30} color={isSelected ? "#fff" : "#5dc5fa"} />
//                           </div>
//                           <p
//                             className="mt-2 mb-0 fw-bold"
//                             style={{
//                               fontSize: "14px",
//                               color: isSelected ? "#5dc5fa" : "#333",
//                               letterSpacing: "0.3px",
//                             }}
//                           >
//                             {brand}
//                           </p>
//                         </div>
//                       );
//                     })}

//                     <div
//                       className="category-card text-center d-flex flex-column justify-content-center"
//                       onClick={() => setShowDrawer(true)}
//                       style={{
//                         minWidth: "145px",
//                         border: "1px dashed #ced4da",
//                         borderRadius: "24px",
//                         padding: "20px 12px",
//                         cursor: "pointer",
//                         background: "#fdfdfd",
//                         transition: "all 0.25s ease",
//                         boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
//                       }}
//                       onMouseOver={(e) => {
//                         e.currentTarget.style.borderColor = "#5dc5fa";
//                         e.currentTarget.style.background = "#FFF5F0";
//                         e.currentTarget.style.transform = "translateY(-6px)";
//                         e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.12)";
//                       }}
//                       onMouseOut={(e) => {
//                         e.currentTarget.style.borderColor = "#ced4da";
//                         e.currentTarget.style.background = "#fdfdfd";
//                         e.currentTarget.style.transform = "translateY(0)";
//                         e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.06)";
//                       }}
//                     >
//                       <div
//                         className="mx-auto d-flex justify-content-center align-items-center"
//                         style={{ width: "72px", height: "72px" }}
//                       >
//                         <FaThLarge size={28} color="#5dc5fa" />
//                       </div>
//                       <p className="mt-2 mb-0 fw-bold" style={{ fontSize: "14px", color: "#5dc5fa" }}>
//                         More
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Parent Component Render Block */}
//               <div style={{ marginTop: "-20px" }}>
//                 <ParentComponent
//                   refRestCart={refRestCart}
//                   uid={uid}
//                   advertisements={advertisements}
//                   loadingAds={loadingAds}
//                   adError={adError}
//                   adSettings={adSettings}
//                   selectedBrands={selectedBrands}
//                 />
//               </div>

//               <Adv />
//             </div>
//           </div>
//         </div>

//         <Footer />
//       </main>
//     </div>
//   );
// }

// export default Home;


import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Home/Navbar";
import ParentComponent from "./Home/Parent";
import Adv from "./Home/Adv";
import Footer from "./Home/Footer";
import Special from "./Home/Special";
import SignupModal from "./Auth/Overlay.jsx";
import Carousel from "react-bootstrap/Carousel";
import Offcanvas from "react-bootstrap/Offcanvas";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { toast } from "react-toastify";
import { FaFilter, FaSearch, FaStore, FaUtensils, FaClock, FaHamburger, FaThLarge } from "react-icons/fa";

function Home() {
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(true);
  const [uid, setUid] = useState(null);
  const [access, setAccess] = useState(null);
  const [index, setIndex] = useState(0);
  const [banners, setBanners] = useState([]);
  const [loadingBanners, setLoadingBanners] = useState(true);
  const [bannerError, setBannerError] = useState(null);
  const [advertisements, setAdvertisements] = useState([]);
  const [loadingAds, setLoadingAds] = useState(true);
  const [adError, setAdError] = useState(null);

  // Brand filter states
  const [brands, setBrands] = useState([]);
  const [loadingBrands, setLoadingBrands] = useState(true);
  const [brandError, setBrandError] = useState(null);
  const [selectedBrands, setSelectedBrands] = useState([]);

  // Responsive Drawer State
  const [showDrawer, setShowDrawer] = useState(false);

  // Search queries
  const [brandSearch, setBrandSearch] = useState("");
  const [mainSearchQuery, setMainSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);

  // Dynamic Scroll Position Tracker State
  const [isScrolledPastHero, setIsScrolledPastHero] = useState(false);
  const [isSearchSticky, setIsSearchSticky] = useState(false);

  // Use refs to prevent unnecessary re-renders
  const searchTriggerRef = useRef(null);
  const scrollTimeoutRef = useRef(null);

  // Add this state near your other states (around line 30)
  const [totalBrands, setTotalBrands] = useState(0);
  const [loadingTotalBrands, setLoadingTotalBrands] = useState(true);

  // Add this useEffect to fetch total brand count (add it after your existing useEffect for fetching banners)
  useEffect(() => {
    const fetchTotalBrandCount = async () => {
      try {
        setLoadingTotalBrands(true);
        const response = await axios.get("https://backend.frozenwala.com/api/total-brand-count/");
        console.log("total-brand-count : ", response)
        setTotalBrands(response.data.total_brands || 0);
      } catch (err) {
        console.error("Failed to fetch total brand count:", err);
        // Fallback to counting from brands array if API fails
        setTotalBrands(brands.length || 0);
      } finally {
        setLoadingTotalBrands(false);
      }
    };

    fetchTotalBrandCount();
  }, []);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const refRestCart = () => setRefresh(!refresh);

  const [showSignup, setShowSignup] = useState(false);

  // Optimized scroll handler with throttling
  useEffect(() => {
    const handleScroll = () => {
      // Throttle the scroll events
      if (scrollTimeoutRef.current) return;

      scrollTimeoutRef.current = setTimeout(() => {
        // For navbar
        if (window.scrollY > 420) {
          setIsScrolledPastHero(true);
        } else {
          setIsScrolledPastHero(false);
        }

        // For search bar sticky - triggers when hero section is scrolled past
        if (searchTriggerRef.current) {
          const rect = searchTriggerRef.current.getBoundingClientRect();
          // Check if the hero search bar is completely out of view
          const isSticky = rect.bottom < 0;
          setIsSearchSticky(isSticky);
        }

        scrollTimeoutRef.current = null;
      }, 100); // Throttle to 100ms
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  // Handle brand checkbox/card change - memoized
  const handleBrandChange = useCallback((brandName) => {
    setSelectedBrands((prev) => {
      if (prev.includes(brandName)) {
        return prev.filter((b) => b !== brandName);
      } else {
        return [...prev, brandName];
      }
    });
  }, []);

  // Main Banner Search Logic - memoized
  const handleMainSearchSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (!mainSearchQuery.trim()) {
      toast.warning("Please enter a search term!");
      return;
    }
    setIsSearching(true);
    try {
      const response = await axios.get(
        `https://backend.frozenwala.com/api/product/search/?q=${mainSearchQuery}&page=1&page_size=16`
      );
      navigate("/search", {
        state: { results: response.data.results, query: mainSearchQuery },
      });
    } catch (error) {
      console.error("Search error:", error);
      toast.error("No Result Found!");
    } finally {
      setIsSearching(false);
    }
  }, [mainSearchQuery, navigate]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSignup(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const storedUid = localStorage.getItem("user_id");
    const storedAccess = localStorage.getItem("access_token");

    if (!storedUid || !storedAccess) {
      // navigate("/login");
    } else {
      setUid(storedUid);
      setAccess(storedAccess);
    }
  }, [navigate]);

  // Fetch banners
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        setLoadingBanners(true);
        const response = await axios.get("https://backend.frozenwala.com/api/banners/");

        const activeBanners = response.data.filter(
          (banner) => banner.status === true
        );

        const formattedBanners = activeBanners.map((banner) => ({
          id: banner.id,
          image: banner.add_photo,
          title: banner.title,
          description: banner.description,
          originalData: banner,
        }));

        setBanners(formattedBanners);
        setBannerError(null);
      } catch (err) {
        console.error("Failed to fetch banners:", err);
        setBannerError("Failed to load banners. Please try again later.");
      } finally {
        setLoadingBanners(false);
      }
    };

    fetchBanners();
  }, []);

  // Fetch advertisements
  useEffect(() => {
    const fetchAdvertisements = async () => {
      try {
        setLoadingAds(true);
        const response = await axios.get(`https://backend.frozenwala.com/api/adds/`);

        const activeAds = response.data.filter((ad) => ad.status === true);

        const formattedAds = activeAds.map((ad) => ({
          id: ad.id,
          image: ad.add_photo,
          title: ad.title,
          description: ad.description,
          created_at: ad.created_at,
          category: ad.category,
          originalData: ad,
        }));

        setAdvertisements(formattedAds);
        setAdError(null);
      } catch (err) {
        console.error("Failed to fetch advertisements:", err);
        setAdError("Failed to load advertisements.");
      } finally {
        setLoadingAds(false);
      }
    };

    fetchAdvertisements();
  }, []);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        setLoadingBrands(true);
        const response = await axios.get("https://backend.frozenwala.com/api/item-brands/");

        let brandList = response.data;

        if (brandList.length > 0 && typeof brandList[0] === "object") {
          brandList = brandList.map((item) => item.name || item.brand_name || item.title);
        }

        // Sort alphabetically for grouping
        brandList.sort((a, b) => a.localeCompare(b));
        setBrands(brandList);
        setBrandError(null);
      } catch (err) {
        console.error("Failed to fetch brands:", err);
        setBrandError("Failed to load brands.");
      } finally {
        setLoadingBrands(false);
      }
    };

    fetchBrands();
  }, []);

  // Filter brands based on search and group alphabetically - memoized
  const filteredBrands = useMemo(() => {
    return brands.filter((brand) =>
      brand.toLowerCase().includes(brandSearch.toLowerCase())
    );
  }, [brands, brandSearch]);

  // Group filtered brands by first letter - memoized
  const groupedBrands = useMemo(() => {
    return filteredBrands.reduce((groups, brand) => {
      const firstLetter = brand.charAt(0).toUpperCase();
      if (!groups[firstLetter]) {
        groups[firstLetter] = [];
      }
      groups[firstLetter].push(brand);
      return groups;
    }, {});
  }, [filteredBrands]);

  const adSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  // Brand list component (reused in drawer) - memoized
  const BrandList = useMemo(() => {
    return (
      <>
        {loadingBrands ? (
          <div className="text-center py-3">
            <div className="spinner-border spinner-border-sm text-primary" role="status" />
          </div>
        ) : brandError ? (
          <div className="alert alert-warning small py-1 px-2">{brandError}</div>
        ) : Object.keys(groupedBrands).length === 0 ? (
          <p className="text-muted small">No brands found</p>
        ) : (
          Object.keys(groupedBrands)
            .sort()
            .map((letter) => (
              <div key={letter} className="mb-4">
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: "13px",
                    color: "#5dc5fa",
                    borderBottom: "1px solid #eee",
                    paddingBottom: "4px",
                    marginBottom: "10px",
                  }}
                >
                  {letter}
                </div>
                {groupedBrands[letter].map((brand, idx) => (
                  <div
                    key={`${letter}-${idx}`}
                    className="mb-2 d-flex align-items-center gap-3 p-2 rounded"
                    style={{ cursor: "pointer", transition: "0.2s" }}
                    onMouseOver={(e) => (e.currentTarget.style.background = "#f8f9fa")}
                    onMouseOut={(e) => (e.currentTarget.style.background = "transparent")}
                    onClick={() => handleBrandChange(brand)}
                  >
                    <div
                      style={{
                        width: "35px",
                        height: "35px",
                        borderRadius: "50%",
                        background: selectedBrands.includes(brand) ? "#5dc5fa" : "#eee",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "hidden",
                        transition: "0.2s",
                      }}
                    >
                      <FaHamburger size={14} color={selectedBrands.includes(brand) ? "#fff" : "#5dc5fa"} />
                    </div>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: selectedBrands.includes(brand) ? "700" : "500",
                        color: selectedBrands.includes(brand) ? "#5dc5fa" : "#333",
                      }}
                    >
                      {brand}
                    </span>
                  </div>
                ))}
              </div>
            ))
        )}
      </>
    );
  }, [loadingBrands, brandError, groupedBrands, selectedBrands, handleBrandChange]);

  // Search bar component - memoized to prevent re-renders
  const SearchBar = useMemo(() => ({ isSticky = false } = {}) => {
    return (
      <div
        className={isSticky ? "sticky-search-bar" : ""}
        style={{
          position: isSticky ? "fixed" : "relative",
          top: isSticky ? "64px" : "auto",
          left: isSticky ? "0" : "auto",
          right: isSticky ? "0" : "auto",
          zIndex: 999,
          background: isSticky ? "rgba(255, 255, 255, 0.95)" : "transparent",
          padding: isSticky ? "12px 24px" : "0",
          boxShadow: isSticky ? "0 4px 20px rgba(0,0,0,0.08)" : "none",
          transition: "all 0.3s ease",
          transform: isSticky ? "translateY(0)" : "none",
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          backdropFilter: isSticky ? "blur(10px)" : "none",
          borderBottom: isSticky ? "1px solid rgba(0,0,0,0.05)" : "none",
        }}
      >
        <form
          onSubmit={handleMainSearchSubmit}
          className="d-flex align-items-center rounded-3 p-1 p-sm-2"
          style={{
            maxWidth: "600px",
            width: "100%",
            background: isSticky ? "#ffffff" : "rgba(255, 255, 255, 0.9)",
            boxShadow: isSticky ? "0 2px 12px rgba(0,0,0,0.08)" : "0 4px 15px rgba(0,0,0,0.1)",
            border: isSticky ? "1px solid #e0e0e0" : "1px solid rgba(255,255,255,0.3)",
          }}
        >
          <FaSearch className="ms-2 ms-sm-3 text-muted" size={17} style={{ minWidth: "17px" }} />
          <input
            type="text"
            className="form-control border-0 shadow-none px-2 px-sm-3"
            style={{
              fontSize: "clamp(13px, 1.4vw, 15px)",
              height: "clamp(36px, 5vh, 44px)",
              background: "transparent",
            }}
            placeholder="Search for item or product..."
            value={mainSearchQuery}
            onChange={(e) => setMainSearchQuery(e.target.value)}
          />
          <button
            type="submit"
            disabled={isSearching}
            className="btn fw-bold px-3 px-sm-4 rounded-2"
            style={{
              background: "#5dc5fa",
              color: "#fff",
              fontSize: "clamp(13px, 1.4vw, 15px)",
              height: "clamp(36px, 5vh, 44px)",
              whiteSpace: "nowrap",
            }}
          >
            {isSearching ? "..." : "Search"}
          </button>
        </form>
      </div>
    );
  }, [handleMainSearchSubmit, mainSearchQuery, isSearching]);

  return (
    <div style={{ overflowX: "hidden" }}>
      <main className="main" id="top">
        {!access && (
          <SignupModal show={showSignup} onClose={() => setShowSignup(false)} />
        )}
        <Navbar refreshCart={refresh} isCollapsedTop={isScrolledPastHero} />

        {/* Dynamic Global Media Query Override Blocks */}
        <style>{`
          @media (max-width: 991.98px) {
            .main-layout-container { margin-top: 15px !important; }
          }

          /* Web View Specific Overrides to Expand Banner and Clear Navbar */
          @media (min-width: 992px) {
            .desktop-hero-img {
              height: clamp(460px, 66vh, 700px) !important;
            }
            .desktop-hero-content {
              padding-top: max(130px, 16vh) !important;
            }
          }

          /* Custom scrollbar for filter panel */
          .filter-scroll::-webkit-scrollbar {
            width: 6px;
          }
          .filter-scroll::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
          }
          .filter-scroll::-webkit-scrollbar-thumb {
            background: #bbb;
            border-radius: 10px;
          }
          .filter-scroll::-webkit-scrollbar-thumb:hover {
            background: #888;
            border-radius: 10px;
          }
          
          /* Hide scrollbar for categories */
          .category-container::-webkit-scrollbar { display: none; }
          .category-container { -ms-overflow-style: none; scrollbar-width: none; }
          .category-card { transition: 0.3s; }
          .category-card:hover { transform: translateY(-5px); box-shadow: 0 4px 15px rgba(0,0,0,0.05); }

          /* Sticky search bar animation - smooth and clean */
          .sticky-search-bar {
            animation: slideDown 0.35s ease forwards;
          }

          @keyframes slideDown {
            0% {
              opacity: 0;
              transform: translateY(-15px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* Adjust content padding when search is sticky */
          .has-sticky-search {
            padding-top: 80px;
          }

          /* Ensure search input looks clean on transparent background */
          .hero-search-input:focus {
            outline: none;
            box-shadow: none;
          }

          /* Banner text animations */
          .banner-title {
            animation: fadeInUp 0.8s ease forwards;
          }
          .banner-description {
            animation: fadeInUp 0.8s ease 0.2s forwards;
            opacity: 0;
          }
          .banner-subtitle {
            animation: fadeInUp 0.8s ease 0.4s forwards;
            opacity: 0;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* Dark overlay for better text visibility */
          .banner-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(90deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 60%, transparent 100%);
            z-index: 2;
            border-radius: 20px;
          }
        `}</style>

        {/* Added top margin layout rules */}
        <div className="container-fluid main-layout-container" style={{ marginTop: "24px", paddingLeft: "24px", paddingRight: "24px" }}>
          <div className="row">
            {/* Slide Drawer Overlay for "View All" Brands */}
            <Offcanvas show={showDrawer} onHide={() => setShowDrawer(false)} placement="start" style={{ width: "300px" }}>
              <Offcanvas.Header closeButton className="border-b">
                <Offcanvas.Title className="fw-bold fs-5 d-flex align-items-center gap-2" style={{ color: "#5dc5fa" }}>
                  All Brands
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body style={{ overflowY: "auto", display: "flex", flexDirection: "column" }}>
                <div className="input-group mb-3" style={{ borderRadius: "50px", overflow: "hidden" }}>
                  <span className="input-group-text" style={{ background: "#fff", border: "1px solid #ddd", borderRight: "none", borderRadius: "50px 0 0 50px" }}>
                    <FaSearch size={14} color="#aaa" />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search brands..."
                    value={brandSearch}
                    onChange={(e) => setBrandSearch(e.target.value)}
                    style={{
                      border: "1px solid #ddd",
                      borderLeft: "none",
                      borderRadius: "0 50px 50px 0",
                      fontSize: "14px",
                      padding: "8px 12px",
                    }}
                  />
                </div>
                <div className="filter-scroll" style={{ flex: 1, overflowY: "auto" }}>
                  {BrandList}
                </div>
              </Offcanvas.Body>
            </Offcanvas>

            {/* Content Area */}
            <div className="col-12 main-content-area" style={{ paddingLeft: "15px", paddingRight: "15px" }}>

              {/* --- 1. HERO BANNER WITH DYNAMIC CONTENT --- */}
              <div
                className="hero-section position-relative mb-4"
                style={{
                  borderRadius: "20px",
                  overflow: "hidden",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                  isolation: "isolate",
                  transform: "translateZ(0)"
                }}
              >
                {loadingBanners ? (
                  <div className="text-center py-5 bg-white">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading banners...</span>
                    </div>
                    <p className="mt-2">Loading banners...</p>
                  </div>
                ) : bannerError ? (
                  <div className="alert alert-warning text-center" role="alert">{bannerError}</div>
                ) : banners.length > 0 ? (
                  <Carousel
                    activeIndex={index}
                    onSelect={handleSelect}
                    interval={5000}
                    wrap={true}
                    fade
                    indicators={false}
                    controls={false}
                  >
                    {banners.map((slide, idx) => (
                      <Carousel.Item key={slide.id || idx} style={{ borderRadius: "20px", overflow: "hidden" }}>
                        <img
                          className="d-block w-100 desktop-hero-img"
                          src={slide.image}
                          alt={slide.title || `Banner ${idx + 1}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/img/gallery/banner1.jpg";
                          }}
                          style={{
                            height: "clamp(380px, 58vh, 600px)",
                            objectFit: "cover",
                            width: "100%",
                            borderRadius: "20px"
                          }}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  <div className="text-center py-5 bg-white">
                    <p className="text-muted">No active banners available</p>
                  </div>
                )}

                {/* Dark Gradient Overlay */}
                <div className="banner-overlay"></div>

                {/* Dynamic Banner Content */}
                {banners.length > 0 && banners[index] && (
                  <div
                    className="position-absolute w-100 h-100 top-0 start-0 d-flex flex-column justify-content-center desktop-hero-content"
                    style={{
                      zIndex: 3,
                      paddingLeft: "clamp(20px, 5vw, 70px)",
                      paddingRight: "20px",
                      paddingTop: "max(90px, 12vh)",
                      paddingBottom: "20px",
                      overflow: "hidden"
                    }}
                  >
                    <div className="d-flex flex-column justify-content-center w-100">
                      {/* Dynamic Title */}
                      {banners[index].title && (
                        <h1 className="fw-bold mb-2 text-white banner-title" style={{ fontSize: "clamp(1.8rem, 4.5vw, 3.8rem)", lineHeight: "1.2" }}>
                          {banners[index].description}
                        </h1>
                      )}



                      {/* Search Bar with ref for scroll detection */}
                      <div ref={searchTriggerRef} className="banner-subtitle">
                        {SearchBar({ isSticky: false })}
                      </div>

                      {/* Highlights layout */}
                      <div className="d-flex align-items-center mt-3 mt-md-4 gap-2 gap-sm-4 flex-wrap banner-subtitle">
                        <div className="d-flex align-items-center gap-2">
                          <FaStore size={20} color="#5dc5fa" />
                          <div>
                            <h6 className="mb-0 fw-bold text-white" style={{ fontSize: "clamp(0.95rem, 1.5vw, 1.15rem)" }}>200+</h6>
                            <small className="text-light" style={{ fontSize: "11px" }}>Products</small>
                          </div>
                        </div>
                        <div style={{ width: "1px", height: "28px", background: "rgba(255,255,255,0.3)" }}></div>
                        <div className="d-flex align-items-center gap-2">
                          <FaUtensils size={20} color="#5dc5fa" />
                          <div>
                            <h6 className="mb-0 fw-bold text-white" style={{ fontSize: "clamp(0.95rem, 1.5vw, 1.15rem)" }}>1500+</h6>
                            <small className="text-light" style={{ fontSize: "11px" }}>Dishes</small>
                          </div>
                        </div>
                        <div style={{ width: "1px", height: "28px", background: "rgba(255,255,255,0.3)" }}></div>
                        <div className="d-flex align-items-center gap-2">
                          <FaStore size={20} color="#5dc5fa" />
                          <div>
                            <h6 className="mb-0 fw-bold text-white" style={{ fontSize: "clamp(0.95rem, 1.5vw, 1.15rem)" }}>
                              {loadingTotalBrands ? '...' : `${totalBrands}+`}
                            </h6>
                            <small className="text-light" style={{ fontSize: "11px" }}>Brands</small>
                          </div>
                        </div>
                        <div style={{ width: "1px", height: "28px", background: "rgba(255,255,255,0.3)" }}></div>

                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Sticky Search Bar - appears when hero is scrolled past */}
              {isSearchSticky && SearchBar({ isSticky: true })}

              {/* Add padding when sticky search is active */}
              <div className={isSearchSticky ? "has-sticky-search" : ""}>
                {/* --- 2. FILTER BY BRANDS SECTION --- */}
                {/* <div className="mb-4 text-center">
                  <h5 className="fw-bold mb-3 text-dark" style={{ fontSize: "18px" }}>
                    Filter by Brands
                  </h5>

                  <div className="d-flex justify-content-center">
                    <div
                      className="d-flex gap-3 overflow-auto pb-3 pt-1 category-container"
                      style={{
                        scrollBehavior: "smooth",
                        maxWidth: "100%",
                        paddingLeft: "4px",
                        paddingRight: "4px",
                      }}
                    >
                      {brands.slice(0, 7).map((brand, idx) => {
                        const isSelected = selectedBrands.includes(brand);
                        return (
                          <div
                            key={idx}
                            onClick={() => handleBrandChange(brand)}
                            className="category-card text-center"
                            style={{
                              minWidth: "145px",
                              border: isSelected
                                ? "2px solid #5dc5fa"
                                : "1px solid rgba(0,0,0,0.06)",
                              borderRadius: "24px",
                              padding: "20px 12px",
                              cursor: "pointer",
                              background: isSelected
                                ? "linear-gradient(145deg, #FFF5F0 0%, #FFFFFF 100%)"
                                : "#ffffff",
                              transition: "all 0.25s ease",
                              boxShadow: isSelected
                                ? "0 10px 24px rgba(241, 114, 40, 0.25)"
                                : "0 4px 16px rgba(0,0,0,0.06)",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.transform = "translateY(-6px)";
                              e.currentTarget.style.boxShadow = isSelected
                                ? "0 14px 28px rgba(241, 114, 40, 0.30)"
                                : "0 8px 20px rgba(0,0,0,0.12)";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = isSelected
                                ? "0 10px 24px rgba(241, 114, 40, 0.25)"
                                : "0 4px 16px rgba(0,0,0,0.06)";
                            }}
                          >
                            <div
                              className="mx-auto d-flex justify-content-center align-items-center"
                              style={{
                                width: "72px",
                                height: "72px",
                                borderRadius: "50%",
                                background: isSelected
                                  ? "linear-gradient(135deg, #5dc5fa, #5dc5fa)"
                                  : "linear-gradient(135deg, #f8f9fa, #e9ecef)",
                                overflow: "hidden",
                                transition: "0.3s",
                                boxShadow: isSelected
                                  ? "0 6px 18px rgba(241, 114, 40, 0.45)"
                                  : "0 2px 8px rgba(0,0,0,0.08)",
                              }}
                            >
                              <FaHamburger size={30} color={isSelected ? "#fff" : "#5dc5fa"} />
                            </div>
                            <p
                              className="mt-2 mb-0 fw-bold"
                              style={{
                                fontSize: "14px",
                                color: isSelected ? "#5dc5fa" : "#333",
                                letterSpacing: "0.3px",
                              }}
                            >
                              {brand}
                            </p>
                          </div>
                        );
                      })}

                      <div
                        className="category-card text-center d-flex flex-column justify-content-center"
                        onClick={() => setShowDrawer(true)}
                        style={{
                          minWidth: "145px",
                          border: "1px dashed #ced4da",
                          borderRadius: "24px",
                          padding: "20px 12px",
                          cursor: "pointer",
                          background: "#fdfdfd",
                          transition: "all 0.25s ease",
                          boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.borderColor = "#5dc5fa";
                          e.currentTarget.style.background = "#FFF5F0";
                          e.currentTarget.style.transform = "translateY(-6px)";
                          e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.12)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.borderColor = "#ced4da";
                          e.currentTarget.style.background = "#fdfdfd";
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.06)";
                        }}
                      >
                        <div
                          className="mx-auto d-flex justify-content-center align-items-center"
                          style={{ width: "72px", height: "72px" }}
                        >
                          <FaThLarge size={28} color="#5dc5fa" />
                        </div>
                        <p className="mt-2 mb-0 fw-bold" style={{ fontSize: "14px", color: "#5dc5fa" }}>
                          More
                        </p>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* Parent Component Render Block */}
                <div style={{ marginTop: "-20px" }}>
                  <ParentComponent
                    refRestCart={refRestCart}
                    uid={uid}
                    advertisements={advertisements}
                    loadingAds={loadingAds}
                    adError={adError}
                    adSettings={adSettings}
                    selectedBrands={selectedBrands}
                  />
                </div>

                <Adv />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </main>
    </div>
  );
}

export default Home;